export const capitalizeWords = (str) => {
	return str.toLowerCase().replace(/(?:^|\s)\S/g, (char) => char.toUpperCase());
};
